{
	"type": "line",
	"minzoom": 8,
	"layout": {},
	"paint": { "line-color": "#00c5ff", "line-width": 3 }
}
